module.exports = __webpack_public_path__ + "img/multitasking.f987adf1.jpg";